import type {CollectionProxy} from '@bitstillery/common/lib/collection'

/**
 * Portal shop offer cards (`variant === 'offer'`):
 *
 * - **vertical** — Collection grid mode (`.c-collection-view.grid`).
 * - **horizontal** — Collection list mode (`.c-collection-view.list`); narrow vs wide rows use
 *   **container queries** on `.c-collection-view` (see `css/shop/card/collection-product-horizontal.css`).
 *
 * Other collection variants (`cart`, `list` for non-offer, etc.) do not use this classification.
 */
export type PortalOfferProductCardLayout = 'vertical' | 'horizontal'

export function offer_card_layout_data_attr(layout: PortalOfferProductCardLayout | null): string | undefined {
    if (layout == null) {
        return undefined
    }
    return layout.replace(/_/g, '-')
}

/**
 * Resolves the offer card layout for portal `CollectionProduct` (`variant === 'offer'`).
 * Returns `null` when the product is not an offer card (guest, cart, other variants).
 */
export function resolve_portal_offer_card_layout(attrs: {
    variant: 'grid' | 'list' | 'cart' | 'offer'
    collection: CollectionProxy
}): PortalOfferProductCardLayout | null {
    if (attrs.variant !== 'offer') {
        return null
    }
    if (attrs.collection.state.view.mode === 'grid') {
        return 'vertical'
    }
    return 'horizontal'
}
